import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { initializeApp } from 'firebase/app';
import { environment } from '../../environments/environment';
import { FIREBASE_APP } from './firebase-app.token';

export const provideFirebaseApp = (): EnvironmentProviders =>
  makeEnvironmentProviders([
    {
      provide: FIREBASE_APP,
      useFactory: () => initializeApp(environment.firebaseConfig),
    },
  ]);
